/**
 * Layout math for the Telegram Library grid (DayChannelPanel).
 *
 * Telegram dual display (#444): the channel panels used to force themselves
 * EXPANDED so a fixed 5-per-row grid had room, which made them a blocking
 * overlay over the chat and any paired feature. They now live in the standard
 * split slot like every other module, so the column count is CONTAINER-driven:
 * up to 5 per row when the panel is wide (an expanded desktop panel still shows
 * exactly 5), fewer as the panel narrows, never a card narrower than MIN_CARD_W.
 * A docked split column can be narrow while the VIEWPORT is wide, so this is
 * fed the panel's own measured width, never a viewport breakpoint (#142/#231).
 */
export const GRID_GAP = 16;      // px — gap between rows/columns
export const MAX_COLUMNS = 5;
export const MIN_CARD_W = 150;   // px — narrowest a day card may get
export const GRID_PAD_X = 48;    // px — the grid viewport's px-6

// Below this panel width the Library/Focus headers use their compact layout
// (smaller title, world toggle + search on their own rows, tighter controls) so
// nothing spills at the 380px split-slot floor (#243 containment).
export const COMPACT_BELOW = 640;

export function gridColumnsFor(panelWidth) {
    if (!panelWidth || panelWidth <= 0) return MAX_COLUMNS; // not measured yet
    const content = Math.max(0, panelWidth - GRID_PAD_X);
    const cols = Math.floor((content + GRID_GAP) / (MIN_CARD_W + GRID_GAP));
    return Math.max(1, Math.min(MAX_COLUMNS, cols));
}
